export const cities = [
    "Seoul",
    "Ho Chi Minh City",
    "New York",
    "Osaka",
    "Los Angeles",
];